import { Color } from '@kite-js/theme-types';

const green: Color = {
    // Remove this block when do SKYWL-471
    // ------------------------------
    100: '#D8EED5',
    200: '#66BE5B',
    400: '#28871C',
    // ------------------------------

    50: '#ECF7EC',
    300: '#00AA00',
    500: '#006600',
};

export default green;
